import { createContext } from 'react';

import { Theme } from './index.types';

export const ThemeContext = createContext<Theme | null>(null);
